export default class CancelledRequestError extends Error {
  constructor(message = 'Request was cancelled') {
    super(message);
    this.name = 'CancelledRequestError';
  }
}
